import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import "../styles/model.scss";

const categories = ["All", "Men", "Women"];

const ModelsPage: React.FC = () => {
  const [models, setModels] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    const fetchModels = async () => {
      const modelsCollection = collection(db, "models");
      const snapshot = await getDocs(modelsCollection);
      const modelsList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setModels(modelsList);
    };

    fetchModels();
  }, []);

  const filteredModels =
    selectedCategory === "All"
      ? models
      : models.filter((model) => model.category === selectedCategory);

  return (
    <div className="models-container">
      <div className="filter-buttons">
        {categories.map((category) => (
          <button
            key={category}
            className={selectedCategory === category ? "active" : ""}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="models-grid">
        {filteredModels.length > 0 ? (
          filteredModels.map((model) => (
            <div key={model.id} className="model-card">
              <Link to={`/model/${model.id}`}>
                <div className="image-wrapper">
                  <img
                    src={model.images?.[0] || "/fallback.jpg"}
                    alt={model.name}
                    loading="lazy"
                  />
                  <div className="hover-overlay" />
                </div>
                <div className="model-info">
                  <h4>{model.name}</h4>
                  <p>{model.category}</p>
                </div>
              </Link>
            </div>
          ))
        ) : (
          <p>Loading models...</p>
        )}
      </div>
    </div>
  );
};

export default ModelsPage;